import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, computed, inject, input, effect, Signal, WritableSignal, signal, OnInit } from '@angular/core';
import { SafeHtmlPipe } from 'libs/shared/pipes/safe-html.pipe';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap, distinctUntilChanged } from 'rxjs/operators';
import { IconRegistryService } from 'libs/core/cache/icon-registry.service';

@Component({
  selector: 'lib-icon',
  imports: [CommonModule, SafeHtmlPipe],
  template: `
    @if(svg()){
      <span  [innerHTML]="(svg()!) | safeHtml" class="block w-full h-full size-6"></span>
    }

  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    :host svg {
      height: 100%;
      width: 100%; /* <-- Important: NO ocupar tot l'ample */      
    }
  `

})
export class IconComponent {
  name = input.required<string>();

  private registry = inject(IconRegistryService);

  /**
   * Convertim el signal a Observable i fem switchMap
   * perquè si canvia el name, cancel·lem la request anterior i fem la nova.
   */
  private name$ = toObservable(this.name).pipe(
    distinctUntilChanged()
  );
  /**
   * svg és un Signal<string | undefined> que s’actualitza automàticament.
   * No cal subscribe, ni ngOnInit, ni takeUntilDestroyed.
   */
  readonly svg = toSignal(
    this.name$.pipe(
      switchMap((name) => this.registry.getIcon$(name))
    ),
    { initialValue: undefined }
  );

  /**
   * Opcional: booleà per template (per llegibilitat).
   */
  readonly hasSvg = computed(() => !!this.svg());
}
